import { render } from "./RequestAccountDeletion.vue?vue&type=template&id=3098abb6"
import script from "./RequestAccountDeletion.vue?vue&type=script&lang=js"
export * from "./RequestAccountDeletion.vue?vue&type=script&lang=js"

import exportComponent from "/home/alberto/repos/veltium/lan/web-firebase/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__